import Model from "./Model";
import User from "./User";

export default class Simulation extends Model{
  static type = "simulations";
	metadata!: any;
	userId!: User;
}
